// src/config/authConfig.ts
import { Configuration, LogLevel } from "@azure/msal-browser";

// Log the environment variables used for configuration
const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;
const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID;

if (!clientId || clientId.trim() === "") {
  console.error("ERROR: Missing REACT_APP_ENTRA_CLIENT_ID environment variable");
}

if (!tenantId || tenantId.trim() === "") {
  console.error("ERROR: Missing REACT_APP_ENTRA_TENANT_ID environment variable");
}



export const msalConfig: Configuration = {
  auth: {
    clientId: clientId || "",
    authority: `https://login.microsoftonline.com/${tenantId || ""}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
    // Adding prompt parameter prevents asking for consent on each login
    // When prompt is not specified, it falls back to 'select_account'
    // Other valid values: 'none', 'consent', 'login'
    // 'none' is good for silent token acquisition
  },
  cache: {
    cacheLocation: "sessionStorage", // Changed from localStorage to sessionStorage for better compatibility
    storeAuthStateInCookie: true, // Keep this true to ensure compatibility with privacy settings that block third-party cookies
    secureCookies: true, // Add secure cookies flag to enhance security
  },
  system: {
    allowRedirectInIframe: true, // This is needed for IE11 support
    // Enhanced logging for authentication issues
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error("[MSAL]", message);
            break;
          case LogLevel.Info:
            // console.info("[MSAL]", message);
            break;
          case LogLevel.Verbose:
            console.debug("[MSAL]", message);
            break;
          case LogLevel.Warning:
            console.warn("[MSAL]", message);
            break;
        }
      },
      // Set to Verbose for more detailed logging during debugging
      logLevel: process.env.NODE_ENV === 'development' ? LogLevel.Verbose : LogLevel.Info,
    },
  },
};

// Request scopes for API access
export const apiLoginRequest = {
  scopes: [
    "api://14c67919-cc08-4797-b386-d08eeb97a5d8/til.pmp.api.readWrite"
  ],
  prompt: "consent"
};

// Request scopes for Microsoft Graph
export const graphLoginRequest = {
  scopes: [
    "User.Read"
  ],
  prompt: "consent"
};



// Roles mapping (from Microsoft Entra ID to your application)
export const roleMapping = {
  "Admin": "admin",
  "User": "user",
};

